import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function CardRedirectionArbitre() {
  return (
    <>
    <Row xs={1} md={2} className="g-4" style={{width:"100%"}}>
        <Col>
          <Card>
            <Card.Img  variant="top" src="/img/classement.webp" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Classements</Card.Title>
              <Card.Text>
                    
              </Card.Text>
              <Link to={`/arbitre/tableau-de-bord/classement`}>
                <Button className="custom-btn" variant="primary" >Voir les classements</Button>
                </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/match2.webp" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Matchs</Card.Title>
              <Card.Text>

              </Card.Text>
              <Link to={`/arbitre/tableau-de-bord/match`}>
                    <Button  className="custom-btn" variant="primary" >Voir les matchs</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/tournoi.jpg" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Equipes</Card.Title>
              <Card.Text>

              </Card.Text>
              <Link to={`/arbitre/tableau-de-bord/equipe`}>
                    <Button  className="custom-btn" variant="primary" >Voir les équipes</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/arbitre.jpg"   />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Proposez d'arbitrer un match</Card.Title>
              <Card.Text>

              </Card.Text>
              <Link to={`/arbitre/tableau-de-bord/arbitrage`}>
                    <Button  className="custom-btn" variant="primary" >Proposer</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
    </Row>

  

    </>
  );
}

export default CardRedirectionArbitre;